<template>
  <div class="cs-page">
    <div id="customer-chat-container" class="cs-window"></div>
  </div>
</template>

<script setup>
import {onMounted, onUnmounted, ref} from 'vue'
import {ElMessage} from 'element-plus'
import apiClient from "@/components/plugins/axios";

const currentUser = ref({})

function loadUserInfo() {
  try {
    const str = localStorage.getItem('userInfo')
    if (str) {
      currentUser.value = JSON.parse(str)
    }
  } catch (e) {
    currentUser.value = {}
  }
}

let chatInstance = null

function genAnonVisitorName() {
  const d = new Date()
  const pad = (n) => n < 10 ? '0' + n : '' + n
  const ts = pad(d.getFullYear() % 100) + pad(d.getMonth() + 1) + pad(d.getDate())
    + pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds())
  return '访客' + ts
}

const loadChatSDK = () => {
  return new Promise((resolve, reject) => {
    if (window.ChatSDK) return resolve(window.ChatSDK)
    const s = document.createElement('script')
    s.src = '/chat-sdk/chat-sdk-sio.js'
    s.onload = () => resolve(window.ChatSDK)
    s.onerror = () => reject(new Error('加载聊天 SDK 失败'))
    document.head.appendChild(s)
  })
}

const initChat = async () => {
  await loadChatSDK()

  const userId = currentUser.value?.id
  const baseUrl = process.env.VUE_APP_API_URL || ''
  const deviceFp = window.ChatSDK?.getDeviceFingerprint?.() || ''
  const token = userId ? (localStorage.getItem('access_token') || '') : ''

  let visitor
  if (userId) {
    const res = await apiClient.get('/api/v1/cs/visitor/visitor/by-user', {
      params: {
        user_id: userId,
        user_role: 'customer',
        device_fingerprint: deviceFp || undefined
      }
    })
    if (res.data.code !== 200 || !res.data.data?.visitor_id) {
      ElMessage.error(res.data.msg || '获取访客信息失败')
      return
    }
    visitor = {
      name: res.data.data.display_name || '客户',
      avatar: res.data.data.avatar || '',
      visitor_id: res.data.data.visitor_id,
      client_userid: userId,
      client_source: 'Website'
    }
  } else {
    visitor = {
      name: genAnonVisitorName(),
      avatar: '',
      client_userid: 0,
      client_source: 'Website'
    }
  }

  chatInstance = window.ChatSDK.init({
    baseUrl,
    kefuId: 0,
    title: '在线客服',
    container: '#customer-chat-container',
    theme: {primaryColor: '#409EFF', backgroundColor: '#ffffff'},
    token,
    visitor,
    onMessage: (msg) => console.log('[CustomerChat] 收到消息:', msg),
    onConnection: (status) => console.log('[CustomerChat] 连接状态:', status),
    onError: (err) => console.error('[CustomerChat] 错误:', err)
  })
}

onMounted(async () => {
  loadUserInfo()
  try {
    await initChat()
  } catch (error) {
    console.error('初始化聊天失败:', error)
    ElMessage.error('初始化聊天失败: ' + (error.message || ''))
  }
})

onUnmounted(() => {
  if (chatInstance) {
    try { chatInstance.destroy() } catch (e) {}
    chatInstance = null
  }
  const el = document.getElementById('customer-chat-container')
  if (el) el.innerHTML = ''
})
</script>

<style scoped>
.cs-page {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 24px 16px;
  background: linear-gradient(180deg, #f5f7fa 0%, #e8ecf1 100%);
  min-height: calc(100vh - 12rem);
}

.cs-window {
  width: 720px;
  max-width: 100%;
  height: 600px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.cs-window :deep(textarea) {
  min-height: 80px;
  max-height: 150px;
}

.cs-window :deep(.cs-input),
.cs-window :deep(.input-area),
.cs-window :deep(.chat-input) {
  min-height: 100px;
}
</style>